module.exports = __webpack_public_path__ + "media/heart2heart-campaign-video.158a2657.mp4";